import { UploadItemCard } from '@app/modules/social-export/publish';
import { FragmentSocialUploadItemDto } from '@app/modules/fragments/fragment.types';
import { useSocialExportUploadItemCardActions } from './useSocialExportUploadItemCardActions';

interface SocialExportUploadItemCardProps {
  upload: FragmentSocialUploadItemDto;
}

/**
 * Fragment social upload card: delegates layout to shared social-export card.
 */
export function SocialExportUploadItemCard({ upload }: SocialExportUploadItemCardProps) {
  const { trigger: actionsTrigger, menuAndDialog: actionsMenuAndDialog } =
    useSocialExportUploadItemCardActions({ upload });

  return (
    <UploadItemCard
      upload={upload}
      actionsTrigger={actionsTrigger}
      actionsMenuAndDialog={actionsMenuAndDialog}
    />
  );
}
